<template>
    <div id="nav-template">
       <div v-if="!hasExtension" class="alert alert-warning" role="alert">
            <span>
                <strong>Hey!</strong> Please install and login to the <a href="https://github.com/ChengOrangeJu/WebExtensionWallet" target="_blank">Nebulas Web Extension Wallet</a> to use the Confession-X service.
            </span>
        </div>
        <nav>
            <div class="brand-text">
                <router-link :to="{ path: '/'}">
                    Forever Story
                    <div class="brand-subtext">"Social Stories that Never End on Nebulas"</div>
                </router-link>   
            </div>
        </nav>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
export default {
    name: 'the-nav',
    computed: {
        ...mapGetters({
            hasExtension: 'getHasExtension'
        })
    },
    methods: {}
}
</script>

<style scoped lang="less">

.navbar {
  border-bottom: 1px solid #ccc;
}

.alert {
    margin-bottom: 0;
    border-radius: 0;
    text-align: center;
}

nav {
    background: transparent;
    position: absolute;
    text-align: center;
    padding: 15px;
    color: #fff;
    width: 100%;

    .brand-text {
        font-size: 32px;
        font-family: 'Comfortaa', cursive;
        margin-bottom: 5px;

        a {
            color: #fff;

            &:hover {
                text-decoration: none;
            }
        }
    }

    .brand-subtext {
        font-style: italic;
        font-size: 13px;
        margin-bottom: 5px;
    }

    .version-tag {
        position: absolute;
        top: 15px; right: 30px;
        color: #88929B;
    }

    .logout {
        cursor: pointer;
        font-size: 14px;
        position: absolute; 
        color: #ccc;
        top: 20px; right: 30px;
    }
}

@media only screen and (max-width: 600px) {
  .version-tag {
      display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/TheTopNav.vue